<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import {
  getAdminWechatAuthSettings,
  saveAdminWechatAuthSettings,
  type AdminWechatAuthSettings
} from "../admin-api";

const loading = ref(false);
const saving = ref(false);
const secretPreview = ref("未配置");
const form = reactive({
  enabled: false,
  appId: "",
  appSecret: ""
});

onMounted(loadSettings);

async function loadSettings() {
  loading.value = true;
  try {
    applySettings(await getAdminWechatAuthSettings());
  } catch (currentError) {
    message.error(currentError instanceof Error ? currentError.message : "微信登录配置加载失败。");
  } finally {
    loading.value = false;
  }
}

async function submitSettings() {
  saving.value = true;
  try {
    const response = await saveAdminWechatAuthSettings({
      enabled: form.enabled,
      appId: form.appId,
      appSecret: form.appSecret || undefined
    });
    message.success(response.message);
    form.appSecret = "";
    await loadSettings();
  } catch (currentError) {
    message.error(currentError instanceof Error ? currentError.message : "微信登录配置保存失败。");
  } finally {
    saving.value = false;
  }
}

function applySettings(settings: AdminWechatAuthSettings) {
  form.enabled = settings.enabled ?? false;
  form.appId = settings.appId ?? "";
  form.appSecret = "";
  secretPreview.value = settings.appSecret?.hasValue ? settings.appSecret.preview : "未配置";
}
</script>

<template>
  <a-card class="admin-settings-card" :loading="loading">
    <template #title>微信登录配置</template>
    <template #extra>
      <a-tag :color="form.enabled ? 'green' : 'red'">{{ form.enabled ? "已启用" : "未启用" }}</a-tag>
    </template>

    <a-alert
      class="admin-form-alert"
      type="info"
      show-icon
      message="中国版 .cn 域名显示微信登录入口。这里维护微信开放平台网站应用的 AppID / AppSecret，和微信支付商户号分开配置。"
    />

    <a-form layout="vertical" :model="form" @finish="submitSettings">
      <a-form-item>
        <a-switch v-model:checked="form.enabled" />
        <span style="margin-left: 10px">启用微信登录</span>
      </a-form-item>

      <a-form-item label="微信开放平台 AppID">
        <a-input v-model:value="form.appId" placeholder="wx..." />
      </a-form-item>

      <a-form-item label="微信开放平台 AppSecret">
        <a-input-password v-model:value="form.appSecret" :placeholder="`留空不修改，当前：${secretPreview}`" />
      </a-form-item>

      <a-button type="primary" html-type="submit" :loading="saving">保存微信登录配置</a-button>
    </a-form>
  </a-card>
</template>
